import type { PermissionContext } from '@ardoq/access-control';
import type { ComponentPreviewsState } from '@ardoq/component-overview/componentPreviews';
import { NavigatorLayoutState } from '../types';
import type {
  LoadErrorMessageKey,
  LoadingMessageKey,
} from '../streams/loadStatusKey';

const setDataErrorMessage = (
  state: NavigatorLayoutState,
  dataErrorMessage: LoadErrorMessageKey | null
): NavigatorLayoutState => ({
  ...state,
  dataErrorMessage,
});

const setDataLoadingMessage = (
  state: NavigatorLayoutState,
  dataLoadingMessage: LoadingMessageKey | null
): NavigatorLayoutState => ({
  ...state,
  dataLoadingMessage,
});

const setComponentPreviews = (
  state: NavigatorLayoutState,
  componentPreviews: ComponentPreviewsState
): NavigatorLayoutState => ({
  ...state,
  componentPreviews,
});

const setPermissionContext = (
  state: NavigatorLayoutState,
  permissionContext: PermissionContext | null
): NavigatorLayoutState => ({
  ...state,
  permissionContext,
});

export const navigatorOperations = {
  setDataErrorMessage,
  setDataLoadingMessage,
  setComponentPreviews,
  setPermissionContext,
};
